import { Link, useSearchParams } from 'react-router-dom';
import AuthLayout from '../components/AuthLayout';

export default function Error() {
  const [searchParams] = useSearchParams();
  const errorCode = searchParams.get('code') || '404';
  const errorMessage =
    searchParams.get('message') || "The page you're looking for doesn't exist.";

  const getErrorIcon = () => {
    if (errorCode === '403') {
      return (
        <svg
          className="h-16 w-16 text-red-400"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          <path d="M6 10V7a6 6 0 1112 0v3" />
        </svg>
      );
    }

    return (
      <svg
        className="h-16 w-16 text-gray-400"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    );
  };

  const getErrorTitle = () => {
    switch (errorCode) {
      case '403':
        return 'Access Denied';
      case '404':
        return 'Page Not Found';
      case '500':
        return 'Server Error';
      default:
        return 'Something Went Wrong';
    }
  };

  return (
    <AuthLayout>
      <div className="text-center">
        {/* Error Icon */}
          <div className="flex justify-center">{getErrorIcon()}</div>

          {/* Error Code */}
          <div className="mt-4">
            <span className="inline-block px-3 py-1 text-sm font-semibold text-gray-600 bg-gray-100 rounded-full">
              Error {errorCode}
            </span>
          </div>

          {/* Error Title */}
          <h1 className="mt-4 text-3xl font-bold text-gray-900">
            {getErrorTitle()}
          </h1>

          {/* Error Message */}
          <p className="mt-2 text-gray-600">{errorMessage}</p>

          {/* Actions */}
          <div className="mt-8 space-y-3">
            <Link to="/login" className="btn-primary block text-center">
              Go to Login
            </Link>
            <button
              onClick={() => window.history.back()}
              className="btn-secondary"
            >
              Go Back
            </button>
          </div>

        {/* Help Text */}
        <p className="mt-6 text-sm text-gray-500">
          If you believe this is an error, please contact support.
        </p>
      </div>
    </AuthLayout>
  );
}

